import React from 'react';
import PropTypes from 'prop-types';
import { format } from '../money-display';

function RevenueRenderer(props) {
  const { value } = props;
  if (value === null) {
    // groupping
    return null;
  }
  let display = format(value, true, 1); // do not use Money Display, as this one will only render without prefix and suffix
  if (display === '0.0') {
    display = '0';
  }
  return (
    <div>
      {display}
    </div>
  );
}

RevenueRenderer.propTypes = {
  value: PropTypes.number,
};
RevenueRenderer.defaultProps = {
  value: null,
};

export default RevenueRenderer;
